// ComprasService.js - Servicio para gestión de compras
import { getApiUrl } from '../utils/api';

class ComprasService {
  // Obtener compras con filtros
  async getCompras(filtros = {}) {
    try {
      const baseURL = getApiUrl();
      console.log('ComprasService: Enviando request a:', baseURL);
      console.log('ComprasService: Filtros:', filtros);
      console.log('ComprasService: Filtro fecha activo:', filtros.filtroFecha);
      console.log('ComprasService: Corte seleccionado:', filtros.corteSeleccionado);

      const response = await fetch(baseURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getCompras',
          ...filtros
        })
      });

      console.log('ComprasService: Response status:', response.status);
      console.log('ComprasService: Response ok:', response.ok);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('ComprasService: Error response text:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, response: ${errorText.substring(0, 200)}...`);
      }

      const responseText = await response.text();
      console.log('ComprasService: Raw response:', responseText.substring(0, 500));
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (parseError) {
        console.error('ComprasService: JSON parse error:', parseError);
        console.error('ComprasService: Raw response was:', responseText);
        throw new Error(`Invalid JSON response: ${responseText.substring(0, 200)}...`);
      }
      
      console.log('ComprasService: Parsed data:', data);
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener compras');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getCompras:', error);
      throw error;
    }
  }

  // Obtener lista de proveedores
  async getProveedores() {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getProveedores'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener proveedores');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getProveedores:', error);
      throw error;
    }
  }

  // Obtener lista de ingredientes
  async getIngredientes() {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getIngredientes'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener ingredientes');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getIngredientes:', error);
      throw error;
    }
  }

  // Crear nueva compra
  async crearCompra(compraData) {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'crearCompra',
          ...compraData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al crear compra');
      }

      return data.data;
    } catch (error) {
      console.error('Error en crearCompra:', error);
      throw error;
    }
  }

  // Crear abono para una compra
  async crearAbono(abonoData) {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'crearAbono',
          ...abonoData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al crear abono');
      }

      return data.data;
    } catch (error) {
      console.error('Error en crearAbono:', error);
      throw error;
    }
  }

  // Obtener detalle de compra
  async getCompraDetalle(idCompra) {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getCompraDetalle',
          idCompra: idCompra
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener detalle de compra');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getCompraDetalle:', error);
      throw error;
    }
  }

  // Obtener abonos de una compra
  async getAbonosCompra(idCompra) {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getAbonosCompra',
          idCompra: idCompra
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener abonos');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getAbonosCompra:', error);
      throw error;
    }
  }

  // Obtener cortes disponibles
  async getCortes() {
    try {
      const response = await fetch(getApiUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          tipo: 'getCortes'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.message || 'Error al obtener cortes');
      }

      return data.data || [];
    } catch (error) {
      console.error('Error en getCortes:', error);
      throw error;
    }
  }

  // Formatear filtros para envío a la API
  formatearFiltros(filtros) {
    // Convertir fechas de YYYY-MM-DD a DD/MM/YYYY para el backend sin afectar zona horaria
    const convertirFecha = (fechaISO) => {
      if (!fechaISO) return '';
      const [año, mes, dia] = fechaISO.split('-');
      return `${dia}/${mes}/${año}`;
    };

    return {
      proveedor: filtros.proveedor || '',
      estatus: filtros.estatus || '',
      fechaDesde: convertirFecha(filtros.fechaDesde),
      fechaHasta: convertirFecha(filtros.fechaHasta),
      filtroFecha: filtros.filtroFecha || 'todas',
      corteSeleccionado: filtros.corteSeleccionado || ''
    };
  }
}

// Exportar instancia singleton
const comprasService = new ComprasService();
export default comprasService;